import { redirect } from 'react-router-dom'
import AnonymousGuard from '@/components/guards/AnonymousGuard'
import AccountPageGuard from '@/components/auth/AccountPageGuard'
import SettingsPage from '@/routes/dashboard/settings/SettingsPage'
import MattersPage from '@/matter/components/MattersPage'
import OutlookLinkPage from '@/outlook-link/components/OutlookLinkPage'
import { kRouteSegments } from '@/routing/paths'
import type { RouteFactory } from '@/routing/types'
import ErrorPage from '@/components/error/error-page'
import { OcrUsagePage } from '@/ocr_quota/components/OcrUsagePage'
import { accountPaths } from '@/routing/paths'
import { SettingsModalRedirectRoute } from '@/settings-modal'

/**
 * Creates core dashboard routes for home, account, settings, and matters.
 * These routes are direct children of the dashboard layout.
 * Note: Drive/files routes are now under matter-first routing (/dashboard/m/:matterId/files/...).
 */
export const createCoreRoutes: RouteFactory = () => [
  // Dashboard root redirects to matters table
  {
    path: '',
    loader: () => redirect('matters'),
  },
  {
    path: 'account',
    element: (
      <SettingsModalRedirectRoute resolveByRole>
        <AccountPageGuard />
      </SettingsModalRedirectRoute>
    ),
  },
  {
    path: accountPaths.usage,
    element: (
      <AnonymousGuard>
        <OcrUsagePage />
      </AnonymousGuard>
    ),
  },
  {
    path: 'settings',
    element: (
      <AnonymousGuard>
        <SettingsModalRedirectRoute section="preferences">
          <SettingsPage />
        </SettingsModalRedirectRoute>
      </AnonymousGuard>
    ),
  },
  {
    path: 'matters',
    element: (
      <AnonymousGuard>
        <MattersPage />
      </AnonymousGuard>
    ),
  },
  // Linking the Microsoft account used in the Outlook add-in (kOutlookLinkPath).
  {
    path: kRouteSegments.linkOutlook,
    element: (
      <AnonymousGuard>
        <OutlookLinkPage />
      </AnonymousGuard>
    ),
  },
  //-- ORGANIZATION DRIVE --//
  // deprecated route, redirect to error page
  {
    path: 'drives/org-drive/*',
    element: (
      <AnonymousGuard>
        <ErrorPage />
      </AnonymousGuard>
    ),
  },
]
